import { DateTimeFactory } from "../../../../../../localization/useDateTime"
import { BookingTimeType, ClosingTimeType, CreateCarResource, CreateCarResourceForm } from "../../resourcesTypes"

export const transformCarFormToResource = (
    form: CreateCarResourceForm,
    dateTimeFactory: DateTimeFactory,
): CreateCarResource => {
    const { closingTimesDaily, bookingTimeType, bookingTime, ...rest } = form
    const isAcceptBooking = bookingTimeType === BookingTimeType.ACCEPT_BOOKING_TIME

    const closingTimes = form.closingTimes
        .filter((time) => {
            if (time.type === ClosingTimeType.DAILY) return !isAcceptBooking
            return true
        })
        .map((time) => {
            if (time.type === ClosingTimeType.DAILY && !isAcceptBooking && closingTimesDaily) {
                return {
                    ...time,
                    periodInTime: {
                        from: dateTimeFactory.toHourMinute(closingTimesDaily.periodInTime?.from),
                        to: dateTimeFactory.toHourMinute(closingTimesDaily.periodInTime?.to),
                    },
                }
            }
            return time
        })

    return {
        ...rest,
        closingTimes,
        bookingTime:
            isAcceptBooking && bookingTime
                ? {
                      periodInTime: {
                          from: dateTimeFactory.toHourMinute(bookingTime.periodInTime?.from),
                          to: dateTimeFactory.toHourMinute(bookingTime.periodInTime?.to),
                      },
                  }
                : undefined,
    }
}
